import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const TeaserWrapperImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  height: auto;
  display: flex;
  align-items: ${props => props.justify};
  flex-direction: column;
  > img {
    max-width: 100%;
    width: auto;
    height: auto;
    max-height: 100%;
  }
`

const Paragraph = styled.p`
  font-size: 12px;
`

const Image = ({ image, alt, legend, height, width, justify }) => {
  return (
    <TeaserWrapperImage justify={justify}>
      <img src={image} alt={alt} />
      {legend && <Paragraph>{legend}</Paragraph>}
    </TeaserWrapperImage>
  )
}

Image.propTypes = {
  image: PropTypes.string.isRequired,
  justify: PropTypes.oneOf(["center", "start", "end"]),
  legend: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

Image.defaultProps = {
  justify: "center",
}

export { Image }
